import React from "react"
import { CardContent, CardHeader, CardTitle } from "../ui/card"
import { AnimatedCard } from "../ui/animated-card"
import { Zap, Users, Layers } from "lucide-react"
import { Link, useLocation } from "react-router-dom"
import { Button } from "../ui/button"
import { ArrowRight } from "lucide-react"
import { EventCategory } from "../../lib/analytics"
import { safeTrackEvent } from "../../lib/analytics-utils"

export function CoreOfferings() {
  const location = useLocation();
  
  const handleLearnMore = (category: string, link: string) => {
    safeTrackEvent({
      category: EventCategory.Navigation,
      label: `nav_home_learn_more_${category.toLowerCase().replace(/ /g, '_')}`,
      context: {
        sourcePage: location.pathname,
        destinationPage: link,
        serviceCategory: category
      }
    });
  };

  return (
    <section id="core-offerings" className="container relative z-10 pt-10 pb-6 space-y-12 rounded-lg">
      <div className="text-center space-y-4">
        <h2 className="text-3xl font-bold tracking-tighter sm:text-4xl">
          How We Work
        </h2>
        <p className="mx-auto max-w-[700px] text-muted-foreground">
          Choose the engagement model that fits your needs
        </p>
      </div>
      <div className="grid gap-8 md:grid-cols-3">
        {[
          {
            category: "AI Kickstarter",
            description:
              "A fully trained Partner AI in 8 weeks. We focus on one area of your business, build the Knowledge Architecture and deploy AI that proves value before you commit to more.",
            icon: Zap,
            link: "/services/ai-kickstarter"
          },
          {
            category: "Strategic Transformation",
            description:
              "Comprehensive AI transformation for organisations committed to lasting change. An embedded partnership that builds enterprise-wide Knowledge Architecture and Partner AI capability, with systematic knowledge transfer.",
            icon: Users,
            link: "/services/strategic-transformation"
          },
          {
            category: "Individual Services",
            description:
              "Need specific capability? Access our individual services directly - Knowledge Engineering, Partner AI, Operational Assessment or AI Opportunity Identification. Build what you need, when you need it.",
            icon: Layers,
            link: "/services"
          },
        ].map((service, index) => {
          const Icon = service.icon
          return (
            <AnimatedCard
              key={service.category}
              delay={index * 0.1}
              className="flex flex-col justify-between h-full"
            >
              <CardHeader>
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 rounded-full bg-primary flex items-center justify-center">
                    <Icon className="w-6 h-6 text-primary-foreground" strokeWidth={2} />
                  </div>
                  <CardTitle>{service.category}</CardTitle>
                </div>
                <p className="text-muted-foreground">{service.description}</p>
              </CardHeader>
              <CardContent>
                <Button
                  variant="ghost"
                  asChild
                  className="group text-foreground hover:bg-primary hover:text-primary-foreground transition-colors"
                  onClick={() => handleLearnMore(service.category, service.link)}
                >
                  <Link to={service.link}>
                    Learn More{" "}
                    <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                  </Link>
                </Button>
              </CardContent>
            </AnimatedCard>
          )
        })}
      </div>
    </section>
  )
} 